<template>
 <div class="ui centered grid">
    <div class="three wide column"></div>
    <div class="four wide column">
       <img class="ui fluid image" src="/static/images/ottavio_strada.jpg">
    </div>
    <div class="six wide column">
      <h2>
        401 Unauthorized
      </h2>
      <p>
      "Halt stranger! You are trying to access restricted area of his majesty Rudolf II."
      </p>
      <p>     
      "Let me introduce myself. My name is Jacopo Strada. I am the antiquary to his Majesty. If you want to <b>pass</b> to the collection, provide a <b>word</b> <a v-on:click="showLoginModal()" style="cursor:pointer">here</a>. If you do not have one you have to talk to…"
      </p>
      <p>
        …
      </p>
      <p>
      "Hmm… I would not ask Filip Lang from Langenfels… I am afraid it would be too expensive… rather go <router-link to="/about_database">here</router-link> and find <i>Dame de compagnie</i> Marketa. She will help you get access to the collection."
      </p>
    </div>
    <div class="three wide column"></div>
</div>
</template>

<script>
  export default {
    name: 'not_authorized',
    components: {
      //  TheNoteForm
    },
    data() {
      return {

      }
    },


    methods: {
      showLoginModal: function() {
        $('#login').modal('show');

      }
    },

    mounted() {



    },


  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/router/not_authorized.vue